import { render } from "./ModalOrderOutOfStock.vue?vue&type=template&id=531c9d34"
import script from "./ModalOrderOutOfStock.vue?vue&type=script&lang=js"
export * from "./ModalOrderOutOfStock.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__